export default __webpack_public_path__ + "static/media/arrowforward.d90aae58.svg";